import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  CementoMapaSelection,
  CementoSection,
  CementoCheckoutState,
  CEMENTO_SECTIONS_ORDER,
} from '../models/cemento-checkout';

@Injectable({
  providedIn: 'root',
})
export class CementoCheckoutFlowService {
  private readonly activeSection$ = new BehaviorSubject<CementoSection>(
    CEMENTO_SECTIONS_ORDER[0]
  );
  private readonly state$ = new BehaviorSubject<CementoCheckoutState>({});

  constructor(private readonly router: Router) {}

  get currentSection(): Observable<CementoSection> {
    return this.activeSection$ as Observable<CementoSection>;
  }

  get currentSectionValue(): CementoSection {
    return this.activeSection$.value;
  }

  get checkoutState(): Observable<CementoCheckoutState> {
    return this.state$ as Observable<CementoCheckoutState>;
  }

  get checkoutStateValue(): CementoCheckoutState {
    return this.state$.value;
  }

  goNext(): void {
    const idx = CEMENTO_SECTIONS_ORDER.indexOf(this.activeSection$.value);
    if (idx >= 0 && idx < CEMENTO_SECTIONS_ORDER.length - 1) {
      this.activeSection$.next(CEMENTO_SECTIONS_ORDER[idx + 1]);
    }
  }

  goBack(): void {
    const current = this.activeSection$.value;
    if (current === 'producto') {
      this.router.navigate(['/cemento/mapa']);
      return;
    }
    const idx = CEMENTO_SECTIONS_ORDER.indexOf(current);
    if (idx > 0) {
      this.activeSection$.next(CEMENTO_SECTIONS_ORDER[idx - 1]);
    }
  }

  setSectionData(
    section: CementoSection,
    data: CementoCheckoutState[CementoSection]
  ): void {
    this.state$.next({
      ...this.state$.value,
      [section]: data,
    });
  }

  clearSectionData(section: CementoSection): void {
    const currentState = this.state$.value;
    const { [section]: _removed, ...rest } = currentState;
    this.state$.next(rest);
  }

  setMapaData(data: CementoMapaSelection): void {
    this.state$.next({
      ...this.state$.value,
      mapa: data,
    });
  }

  setOrderBuy(orderBuy: string | undefined): void {
    this.state$.next({
      ...this.state$.value,
      orderBuy,
    });
  }

  replaceState(state: CementoCheckoutState): void {
    this.state$.next(state);
  }

  openSection(section: CementoSection): void {
    if (CEMENTO_SECTIONS_ORDER.includes(section)) {
      this.activeSection$.next(section);
    }
  }

  reset(): void {
    this.activeSection$.next(CEMENTO_SECTIONS_ORDER[0]);
    this.state$.next({});
  }
}
